import { Controller } from "@hotwired/stimulus"
import axios from 'axios';
import getFriendlyErrorMessage from '../../javascript/helpers/getFriendlyErrorMessage';

import { hideModalCarregando, showModalCarregando } from "../../javascript/modal-carregando";

export default class extends Controller {
  async onSubmit(event) {
    event.preventDefault()
    event.stopImmediatePropagation();

    const form = document.getElementById('form-relatorio-fechamento-mes');
    const formData = new FormData(form);

    // Validar que pelo menos uma situação foi selecionada
    const statusCheckboxes = form.querySelectorAll('input[type="checkbox"][name*="status"]:checked');
    if (statusCheckboxes.length === 0) {
      this.showErrors('É necessário selecionar pelo menos uma situação para gerar o relatório.');
      return;
    }

    try {
      this.hideErrors();
      showModalCarregando('Processando... Por favor aguarde, essa operação pode levar alguns minutos.');
      const response = await axios.post(form.action, formData, {
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));

      const link = document.createElement('a');
      link.href = url;

      const nomeArquivo = `relatorio-fechamento-mes-${this.getDataHoraAtual()}.xlsx`;

      link.setAttribute('download', nomeArquivo);

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
      const message = getFriendlyErrorMessage(err, "Houve um erro ao processar os dados. Por favor, tente novamente");
      this.showErrors(message);
    } finally {
      hideModalCarregando();
    }
  }

  showErrors(message) {
    const container = document.getElementById('error-message-container');
    const errorMessage = document.getElementById('error-message');
    errorMessage.innerHTML = message;
    container.style.display = '';
  }

  hideErrors() {
    const container = document.getElementById('error-message-container');
    const errorMessage = document.getElementById('error-message');
    errorMessage.innerHTML = '';
    container.style.display = 'none';
  }

  getDataHoraAtual() {
    const now = new Date();
    const ano = now.getFullYear();
    const mes = String(now.getMonth() + 1).padStart(2, '0');
    const dia = String(now.getDate()).padStart(2, '0');
    const hora = String(now.getHours()).padStart(2, '0');
    const minuto = String(now.getMinutes()).padStart(2, '0');

    return `${ano}-${mes}-${dia}--${hora}-${minuto}`;
  }
}
